import { useState, useEffect, useRef } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import searchIcon from "../../assets/images/search-icon.png";
import closeIcon from "../../assets/images/close-icon.svg";
import participantsIcon from "../../assets/images/participants-icon.svg";
import micMuteIcon from "../../assets/images/mic-off-outline.svg";
import verticalOptionIcon from "../../assets/images/options-vertical.svg";
import coHostIcon from "../../assets/images/admin-outlined-icon.svg";
import blockIcon from "../../assets/images/block-outline-icon.svg";
import deleteIcon from "../../assets/images/delete-outlined-icon.svg";
import openArrowIcon from "../../assets/images/right-arrow-icon.svg";
import micMuteLightIcon from "../../assets/images/light-mic-off-outline.svg";
import micUnMuteLightIcon from "../../assets/images/light-mic-on-outline.svg";
import accordionIcon from "../../assets/images/accordion-icon.svg";
import { usePubNub } from "pubnub-react";
import { useDispatch, useSelector } from "react-redux";
import { userName } from "../../libs/Users/UsersName";
import stopShareIcon from "../../assets/images/stop-share-icon.svg";
import {
  updateisInvitePopUp,
  updateIsScreen,
  updateIsSideBar,
  updateWhoIsSharingScreen,
} from "../../Store/Actions/PublishStreamAction";
import { MSG_ENM, signalEnum } from "../../libs/signal/signalEnum";
import { ConfirmationPopupMakeCoshotOrBlock } from "../LiveRoomPopUp/ConfirmationPopupMakeCoshotOrBlock";
import PublishStream from "../../libs/DolbyStreaming/PublishStream";

interface props {
  onConfirmationOpenAction?: () => void;
  onConfirmationCloseAction?: () => void;
  setTitle?: (text: string) => void;
  setMessage?: (text: string) => void;
  setDropdownOpenAttendee?: any;
  setSubmenuOpenAttendee?: any;
  setDropdownOpen?: any;
  setSubmenuOpen?: any;
  dropdownOpen?: any;
  dropdownOpenAttendee?: any;
  handleClickForConfirmationPopup?: (
    uuid,
    action,
    isPresenterOrAttendee,
    index,
    email
  ) => void;
}

export const PeopleList = ({
  onConfirmationOpenAction,
  onConfirmationCloseAction,
  setTitle,
  setMessage,
  setDropdownOpenAttendee,
  setSubmenuOpenAttendee,
  setDropdownOpen,
  setSubmenuOpen,
  dropdownOpen,
  dropdownOpenAttendee,
  handleClickForConfirmationPopup,
}: props) => {
  // Settings popup tabs
  const [activeTab, setActiveTab] = useState(1);

  //redux
  const stateData = useSelector((state: any) => state.PublishStreamReducer);
  const dispatch = useDispatch();
  console.log("proples", stateData.publishStreamObj.peoples);

  // for dropdown

  const pubnubObj = usePubNub();

  const dropdownRef = useRef(null);
  const dropdownRefAttendee = useRef(null);

  const channelName = `chatModeration.${stateData.publishStreamObj.webinarid}.${stateData.publishStreamObj.sessionId}`;
  const WebinarChannelName =
    "Webinar." +
    stateData.publishStreamObj.webinarid +
    "." +
    stateData.publishStreamObj.sessionId;

  const handleDropdownClick = (index: number) => {
    console.log("index", index, dropdownOpen);
    setDropdownOpen(dropdownOpen === index ? null : index);
    // setDropdownOpen(!dropdownOpen);
    setSubmenuOpen(false); // Close submenu when toggling dropdown
    setDropdownOpenAttendee(null);
    setSubmenuOpen(false);
  };

  const handleDropdownClickAttendee = (index: number) => {
    setDropdownOpenAttendee(dropdownOpenAttendee === index ? null : index);
    setSubmenuOpenAttendee(false); // Close submenu when toggling dropdown
    setDropdownOpen(null);
    setSubmenuOpen(false);
  };

  const handleSubmenuMouseEnter = () => {
    setSubmenuOpen(true);
  };

  const handleSubmenuMouseLeave = () => {
    setSubmenuOpen(false);
  };

  // const handleClickOutside = (event) => {
  //   if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
  //     setDropdownOpen(null);
  //     setSubmenuOpen(null);
  //   }

  //   if (
  //     dropdownRefAttendee.current &&
  //     !dropdownRefAttendee.current.contains(event.target)
  //   ) {
  //     if(setDropdownOpenAttendee){
  //       setDropdownOpenAttendee(null);
  //     }
  //     if(setSubmenuOpen){
  //       setSubmenuOpen(false);
  //     }

  //   }
  // };

  const goToInvite = () => {
    dispatch(updateisInvitePopUp(true));
  };

  const isAttendeeList = stateData.publishStreamObj.isAttendeeList;
  // const getChannelMetadata = () => {
  //   pubnub.objects.getChannelMetadata({
  //     channel: channelName
  //   }).then((response) => {
  //     if (response.data) {
  //       dispatch(updateIsAttendeeList(response.data.custom.isAttendeeList));
  //           }
  //     console.log('Channel metadata:', response);
  //   }).catch((error) => {
  //     console.error('Error getting metadata:', error);
  //   });
  // };
  // useEffect(()=>{
  //   getChannelMetadata()
  // },[isAttendeeList])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(null);
        setSubmenuOpen(null);
      }

      if (
        dropdownRefAttendee.current &&
        !dropdownRefAttendee.current.contains(event.target)
      ) {
        setDropdownOpenAttendee(null);
        setSubmenuOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  //Variable start
  // const pubnubObj = usePubNub();
  // const channelName = stateData.publishStreamObj.webinarid;
  // const [peoples, setPeoples] = useState([stateData.publishStreamObj.peoples]);
  // const [totalAtendee, setTotalAttendee] = useState(
  //   numberOfAttendees(stateData.publishStreamObj.peoples)
  // );
  // const [totalHost, setTotalHost] = useState(
  //   numberOfHosts(stateData.publishStreamObj.peoples)
  // );

  // useEffect(() => {
  //   setPeoples(stateData.publishStreamObj.peoples);
  //   setTotalAttendee(numberOfAttendees(stateData.publishStreamObj.peoples));
  //   setTotalHost(numberOfHosts(stateData.publishStreamObj.peoples));
  //   //console.log("peoples ==>>> ", peoples);
  // }, [stateData.publishStreamObj.peoples]);
  //Variable end

  //User type start
  function userType(ele) {
    if (ele?.isAdmin) return "Host";
    else if (ele?.isModerator) return "Moderator";
    else if (ele?.isAttendee) return "Attendee";
    else return "CoHost";
  }

  function numberOfAttendees(peoples) {
    let count = 0;
    peoples.forEach((ele) => {
      if (ele?.state?.isAttendee) count++;
    });
    return count;
  }

  function numberOfHosts(peoples) {
    let count = 0;
    peoples.forEach((ele) => {
      if (ele?.state?.isPresentor || ele?.state?.isAdmin  || ele?.state?.isModerator) count++;
    });
    return count;
  }

  const handleClickForMic = (elementState, mic) => {
    if (stateData?.publishStreamObj?.isAdmin ||stateData?.publishStreamObj.isModerator) {
      pubnubObj.publish(
        {
          channel: WebinarChannelName,
          message: {
            type: MSG_ENM.TOGGLE_MIC,
            uuid: elementState.uuid,
            email: elementState.email,
            mutedBy: "admin",
            mic,
          },
        },
        (status, response) => {
          if (status.error) {
            console.log("Publish Error:", status);
          } else {
            console.log("Message Published:", response);
            setDropdownOpenAttendee(null);
            setSubmenuOpenAttendee(false);
          }
        }
      );
    }
  };

  const handleClickForCamera = (elementState, camera) => {
    if (stateData?.publishStreamObj?.isAdmin ||stateData?.publishStreamObj.isModerator) {
      pubnubObj.publish(
        {
          channel: WebinarChannelName,
          message: {
            type: MSG_ENM.TOGGLE_CAMERA,
            uuid: elementState.uuid,
            email: elementState.email,
            mutedBy: "admin",
            camera,
          },
        },
        (status, response) => {
          if (status.error) {
            console.log("Publish Error:", status);
          } else {
            console.log("Message Published:", response);
            setDropdownOpenAttendee(null);
            setSubmenuOpenAttendee(false);
          }
        }
      );
    }
  };

  const handleClickForStopShare = (elementState) => {
    if (stateData?.publishStreamObj?.isAdmin ||stateData?.publishStreamObj.isModerator)  {
      pubnubObj.publish(
        {
          channel: WebinarChannelName,
          message: {
            type: MSG_ENM.STOP_SCREEN_SHARE_FOR_PRESENTER,
            uuid: elementState.uuid,
          },
        },
        (status, response) => {
          if (status.error) {
            console.log("Publish Error:", status);
          } else {
            console.log("Message Published:", response);
            setDropdownOpenAttendee(null);
            setSubmenuOpenAttendee(false);
            setDropdownOpen(null);
       
            dispatch(updateIsScreen(false));
            dispatch(updateWhoIsSharingScreen(""))

          }
        }
      );
    }
  };

  return (
    <>
      <div className="People-area">
        <div
          className="sidebar-header"
          onClick={() => {
            dispatch(updateIsSideBar(false));
          }}
        >
          <a href="#">
            <img src={closeIcon} alt="" />
          </a>
          People
        </div>
        <div className="search-bar">
          {/*  <input
          type="text"
          className="search-input"
          placeholder="Search Participants"
        />
        <span className="flex flex-center search-icon">
          <img src={searchIcon} alt="search icon" />
        </span>*/}
        </div>

        {stateData.publishStreamObj.isAttendee == false &&
          stateData.publishStreamObj.isModerator == false && (
            <div className="invite-button-box">
              <button
                type="button"
                className="primary-button btn-md"
                onClick={goToInvite}
              >
                Invite People
              </button>
            </div>
          )}

        <div className="participants-listing">
          <Accordion
            allowZeroExpanded
            allowMultipleExpanded
            preExpanded={["a"]}
          >
            <AccordionItem uuid="a">
              <AccordionItemHeading>
                <AccordionItemButton>
                  <img src={participantsIcon} alt="participants" /> Presenters (
                  {numberOfHosts(stateData.publishStreamObj.peoples)})
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <div className="participants-list">
                  <ul>
                    {stateData.publishStreamObj.peoples.length > 0 &&
                      stateData.publishStreamObj.peoples
                        .filter(
                          (ele) =>
                            ele?.state?.isPresentor ||
                            ele?.state?.isAdmin ||
                            ele?.state?.isModerator
                        )
                        .map((ele, index) => {
                          console.log("eleeeee", ele);
                          return (
                            <li
                              key={index}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <div className="flex user-info">
                                <span className="flex flex-center alphabet-name">
                                  {userName(ele?.state?.userName)}
                                </span>
                                <div className="flex joined-participants-info">
                                  <span className="username">
                                    {ele?.state?.userName}{" "}
                                    <span className="host">
                                      ({userType(ele?.state)})
                                    </span>
                                  </span>
                                  <span className="flex user-actions">
                                    {userType(ele?.state) !== "Host" &&
                                      !stateData.publishStreamObj.isAttendee &&
                                      !stateData.publishStreamObj.isPresenter &&
                                      userType(ele?.state) !== "Moderator" &&
                                     ( stateData.publishStreamObj.userUUID !==
                                        ele?.state?.uuid ) && (
                                      <>
                                        {ele?.state?.mic == false ? (
                                          <a
                                            onClick={() =>
                                              handleClickForMic(ele.state, true)
                                            }
                                            className={`flex flex-center ${
                                              ele?.state?.mic === false
                                                ? ""
                                                : "mic-on"
                                            }`}
                                          >
                                            <svg
                                              className="off"
                                              width="24"
                                              height="24"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M15.5976 12.0006C15.5976 12.3254 15.5568 12.6362 15.4752 12.933L8.39997 5.85778C8.43431 4.91393 8.83819 4.02138 9.52454 3.37257C10.2109 2.72375 11.1247 2.37065 12.069 2.38938C13.0133 2.40812 13.9124 2.79719 14.5725 3.47272C15.2325 4.14824 15.6007 5.05611 15.5976 6.00058V12.0006ZM8.39757 9.25018V12.0006C8.39763 12.6613 8.57952 13.3092 8.92331 13.8735C9.2671 14.4377 9.75954 14.8964 10.3467 15.1994C10.9338 15.5024 11.593 15.638 12.2521 15.5912C12.9111 15.5445 13.5446 15.3174 14.0832 14.9346L15.3672 16.2186C14.5728 16.853 13.6154 17.2502 12.6052 17.3646C11.5951 17.479 10.5731 17.3059 9.65695 16.8653C8.74079 16.4246 7.96763 15.7343 7.4264 14.8737C6.88518 14.0131 6.59789 13.0172 6.59757 12.0006C6.59051 11.8463 6.5242 11.7006 6.41244 11.5939C6.30068 11.4873 6.15208 11.4278 5.9976 11.428C5.84311 11.4282 5.69464 11.4879 5.58309 11.5948C5.47154 11.7017 5.40552 11.8474 5.39877 12.0018C5.39854 13.6485 6.0139 15.2358 7.12404 16.4521C8.23417 17.6683 9.75887 18.4257 11.3988 18.5754V21.0006C11.3988 21.1597 11.462 21.3123 11.5745 21.4248C11.687 21.5374 11.8396 21.6006 11.9988 21.6006C12.1579 21.6006 12.3105 21.5374 12.423 21.4248C12.5356 21.3123 12.5988 21.1597 12.5988 21.0006V18.5742C13.931 18.4526 15.1948 17.9291 16.2228 17.073L20.574 21.4254C20.6297 21.4812 20.6958 21.5254 20.7686 21.5557C20.8415 21.5859 20.9195 21.6015 20.9983 21.6015C21.0772 21.6016 21.1553 21.5861 21.2281 21.556C21.301 21.5259 21.3672 21.4817 21.423 21.426C21.4788 21.3703 21.523 21.3041 21.5532 21.2313C21.5835 21.1585 21.5991 21.0804 21.5991 21.0016C21.5992 20.9228 21.5837 20.8447 21.5536 20.7718C21.5235 20.699 21.4793 20.6328 21.4236 20.577L3.42357 2.57698C3.36786 2.5212 3.30172 2.47693 3.2289 2.44671C3.15609 2.41649 3.07803 2.4009 2.9992 2.40085C2.92036 2.40079 2.84228 2.41626 2.76943 2.44638C2.69657 2.4765 2.63036 2.52067 2.57457 2.57638C2.51879 2.63209 2.47452 2.69824 2.4443 2.77105C2.41408 2.84387 2.39849 2.92192 2.39844 3.00076C2.39838 3.07959 2.41386 3.15767 2.44397 3.23053C2.47409 3.30338 2.51826 3.3696 2.57397 3.42538L8.39757 9.25018ZM17.7612 15.2202C18.3103 14.236 18.5982 13.1276 18.5976 12.0006C18.5976 11.8415 18.5344 11.6888 18.4218 11.5763C18.3093 11.4638 18.1567 11.4006 17.9976 11.4006C17.8384 11.4006 17.6858 11.4638 17.5733 11.5763C17.4608 11.6888 17.3976 11.8415 17.3976 12.0006C17.3976 12.8346 17.2092 13.6242 16.8708 14.3286L17.7612 15.2202Z"
                                                fill="#333333"
                                              />
                                            </svg>
                                          </a>
                                        ) : (
                                          <a
                                            onClick={() =>
                                              handleClickForMic(
                                                ele.state,
                                                false
                                              )
                                            }
                                            className={`flex flex-center ${
                                              ele.state.mic == false
                                                ? ""
                                                : "mic-on"
                                            }`}
                                          >
                                            <svg
                                              className="on"
                                              width="24"
                                              height="24"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M11.9984 15.6004C12.9532 15.6004 13.8689 15.2211 14.544 14.546C15.2192 13.8708 15.5984 12.9552 15.5984 12.0004V6.00039C15.5984 5.04561 15.2192 4.12994 14.544 3.45481C13.8689 2.77968 12.9532 2.40039 11.9984 2.40039C11.0437 2.40039 10.128 2.77968 9.45285 3.45481C8.77772 4.12994 8.39844 5.04561 8.39844 6.00039V12.0004C8.39844 12.9552 8.77772 13.8708 9.45285 14.546C10.128 15.2211 11.0437 15.6004 11.9984 15.6004ZM11.9984 14.4004C11.3619 14.4004 10.7515 14.1475 10.3014 13.6974C9.85129 13.2474 9.59844 12.6369 9.59844 12.0004V6.00039C9.59844 5.36387 9.85129 4.75342 10.3014 4.30333C10.7515 3.85325 11.3619 3.60039 11.9984 3.60039C12.635 3.60039 13.2454 3.85325 13.6955 4.30333C14.1456 4.75342 14.3984 5.36387 14.3984 6.00039V12.0004C14.3984 12.6369 14.1456 13.2474 13.6955 13.6974C13.2454 14.1475 12.635 14.4004 11.9984 14.4004ZM5.99844 11.4004C6.15757 11.4004 6.31018 11.4636 6.4227 11.5761C6.53522 11.6886 6.59844 11.8413 6.59844 12.0004C6.59844 12.7095 6.73811 13.4117 7.00949 14.0669C7.28086 14.722 7.67862 15.3173 8.18006 15.8188C8.6815 16.3202 9.27679 16.718 9.93195 16.9893C10.5871 17.2607 11.2893 17.4004 11.9984 17.4004C12.7076 17.4004 13.4098 17.2607 14.0649 16.9893C14.7201 16.718 15.3154 16.3202 15.8168 15.8188C16.3183 15.3173 16.716 14.722 16.9874 14.0669C17.2588 13.4117 17.3984 12.7095 17.3984 12.0004C17.3984 11.8413 17.4617 11.6886 17.5742 11.5761C17.6867 11.4636 17.8393 11.4004 17.9984 11.4004C18.1576 11.4004 18.3102 11.4636 18.4227 11.5761C18.5352 11.6886 18.5984 11.8413 18.5984 12.0004C18.5987 13.6471 17.9833 15.2344 16.8732 16.4507C15.763 17.667 14.2383 18.4243 12.5984 18.574V21.0004C12.5984 21.1595 12.5352 21.3121 12.4227 21.4247C12.3102 21.5372 12.1576 21.6004 11.9984 21.6004C11.8393 21.6004 11.6867 21.5372 11.5742 21.4247C11.4617 21.3121 11.3984 21.1595 11.3984 21.0004V18.574C9.75854 18.4243 8.23383 17.667 7.1237 16.4507C6.01357 15.2344 5.39821 13.6471 5.39844 12.0004C5.39844 11.8413 5.46165 11.6886 5.57417 11.5761C5.6867 11.4636 5.83931 11.4004 5.99844 11.4004Z"
                                                fill="#666666"
                                              />
                                            </svg>
                                          </a>
                                        )}

                                        {ele?.state?.camera == false ? (
                                          <a
                                            onClick={() =>
                                              handleClickForCamera(
                                                ele.state,
                                                true
                                              )
                                            }
                                            className={`flex flex-center ${
                                              ele?.state?.camera === false
                                                ? ""
                                                : "cam-on"
                                            }`}
                                          >
                                            <svg
                                              className="off"
                                              width="24"
                                              height="24"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M2.8124 1.90285C2.75354 1.83969 2.68257 1.78903 2.60372 1.75389C2.52486 1.71876 2.43973 1.69987 2.35342 1.69834C2.2671 1.69682 2.18136 1.7127 2.10131 1.74503C2.02127 1.77736 1.94855 1.82549 1.88751 1.88653C1.82646 1.94758 1.77834 2.02029 1.74601 2.10034C1.71367 2.18038 1.6978 2.26612 1.69932 2.35244C1.70084 2.43876 1.71973 2.52388 1.75487 2.60274C1.79001 2.6816 1.84067 2.75257 1.90383 2.81142L4.29697 5.20542C3.56876 5.35159 2.91365 5.74543 2.443 6.32C1.97234 6.89457 1.71519 7.61441 1.71525 8.35714V15.6429C1.71525 16.4953 2.0539 17.3129 2.6567 17.9157C3.25949 18.5185 4.07706 18.8571 4.92954 18.8571H12.2153C12.958 18.8572 13.6778 18.6001 14.2524 18.1294C14.827 17.6587 15.2208 17.0036 15.367 16.2754L21.1887 22.098C21.3093 22.2186 21.4728 22.2863 21.6434 22.2863C21.8139 22.2863 21.9775 22.2186 22.0981 22.098C22.2187 21.9774 22.2865 21.8138 22.2865 21.6433C22.2865 21.4727 22.2187 21.3092 22.0981 21.1886L2.8124 1.90285ZM7.87211 5.14285L15.4295 12.7003V8.35714C15.4295 7.50465 15.0909 6.68709 14.4881 6.08429C13.8853 5.4815 13.0677 5.14285 12.2153 5.14285H7.87211ZM16.2867 13.5574L20.7241 17.9957C21.5238 18.0249 22.2833 17.3983 22.2833 16.494V7.50256C22.2833 6.29399 20.9264 5.58085 19.9313 6.26828L16.2867 8.78485V13.5574Z"
                                                fill="#333333"
                                              />
                                            </svg>
                                          </a>
                                        ) : (
                                          <a
                                            onClick={() =>
                                              handleClickForCamera(
                                                ele.state,
                                                false
                                              )
                                            }
                                            className={`flex flex-center ${
                                              ele.state.camera == false
                                                ? ""
                                                : "mic-on"
                                            }`}
                                          >
                                            <svg
                                              className="on"
                                              width="24"
                                              height="24"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M4.92913 5.14258C4.07665 5.14258 3.25908 5.48123 2.65629 6.08402C2.05349 6.68682 1.71484 7.50438 1.71484 8.35686V15.6426C1.71484 16.4951 2.05349 17.3126 2.65629 17.9154C3.25908 18.5182 4.07665 18.8569 4.92913 18.8569H13.072C13.9245 18.8569 14.742 18.5182 15.3448 17.9154C15.9476 17.3126 16.2863 16.4951 16.2863 15.6426V15.2114L19.9308 17.728C20.9251 18.4146 22.2828 17.7023 22.2828 16.4937V7.50229C22.2828 6.29372 20.9251 5.58058 19.9308 6.26801L16.2863 8.78458V8.35686C16.2863 7.50438 15.9476 6.68682 15.3448 6.08402C14.742 5.48123 13.9245 5.14258 13.072 5.14258H4.92913ZM16.2863 10.3463L20.6611 7.32572C20.6933 7.30351 20.7309 7.29053 20.77 7.28819C20.809 7.28584 20.8479 7.29421 20.8825 7.3124C20.9171 7.33058 20.9461 7.35789 20.9663 7.39136C20.9865 7.42484 20.9972 7.4632 20.9971 7.50229V16.4937C20.9972 16.5328 20.9865 16.5712 20.9663 16.6047C20.9461 16.6381 20.9171 16.6654 20.8825 16.6836C20.8479 16.7018 20.809 16.7102 20.77 16.7078C20.7309 16.7055 20.6933 16.6925 20.6611 16.6703L16.2863 13.648V10.3463ZM3.00056 8.35686C3.00056 7.84537 3.20375 7.35484 3.56542 6.99316C3.9271 6.63148 4.41764 6.42829 4.92913 6.42829H13.072C13.5835 6.42829 14.074 6.63148 14.4357 6.99316C14.7974 7.35484 15.0006 7.84537 15.0006 8.35686V15.6426C15.0006 16.1541 14.7974 16.6446 14.4357 17.0063C14.074 17.368 13.5835 17.5711 13.072 17.5711H4.92913C4.41764 17.5711 3.9271 17.368 3.56542 17.0063C3.20375 16.6446 3.00056 16.1541 3.00056 15.6426V8.35686Z"
                                                fill="#666666"
                                              />
                                            </svg>
                                          </a>
                                        )}
                                      </>
                                    )}

                                    {/* <a href="#" className='flex flex-center'><img src={verticalOptionIcon} alt="vertical icon" /></a> */}
                                    {userType(ele?.state) !== "Host" &&
                                      !stateData.publishStreamObj.isAttendee &&
                                      !stateData.publishStreamObj.isPresenter &&
                                      ( (userType(ele?.state) == "Moderator" || (userType(ele?.state) == "CoHost")))&&
                                      ( !((userType(ele?.state) == "Moderator") && (stateData.publishStreamObj.isModerator)))&&

                                      
                                      stateData.publishStreamObj.userUUID !==
                                        ele?.state?.uuid && (
                                        <div
                                          onClick={(e) => {
                                            e.stopPropagation();
                                          }}
                                          className="dropdown-area"
                                          ref={dropdownRef}
                                        >
                                          <button
                                            onClick={(e) => {
                                              e.stopPropagation();

                                              handleDropdownClick(index);
                                            }}
                                            className="dropdown-button"
                                          >
                                            <img
                                              src={verticalOptionIcon}
                                              alt="vertical icon"
                                            />
                                            
                                          </button>
                                          {dropdownOpen == index && (
                                            <ul className="dropdown-listing">
                                             { (userType(ele?.state) != "Moderator") &&<li
                                                className="dropdown-item"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  handleClickForConfirmationPopup(
                                                    ele?.state?.uuid,
                                                    MSG_ENM.MAKE_ATTENDEE,
                                                    "presenter",
                                                    index,
                                                    ele?.state.email
                                                  );
                                                  setDropdownOpen(null);
                                                }}
                                              >
                                                <img src={coHostIcon} alt="" />{" "}
                                                Make Attendee
                                              </li>}
                                              {/* <li
                                          className="dropdown-item"
                                          onClick={handleMenuItemClick}
                                        >
                                          <img src={micMuteLightIcon} alt="" />{" "}
                                          Mute
                                        </li> */}
                                              <li
                                                className="dropdown-item"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  handleClickForConfirmationPopup(
                                                    ele?.state?.uuid,
                                                    MSG_ENM.BLOCK,
                                                    "presenter",
                                                    index,
                                                    ele?.state.email
                                                  );
                                                }}
                                                onMouseEnter={
                                                  handleSubmenuMouseEnter
                                                }
                                                onMouseLeave={
                                                  handleSubmenuMouseLeave
                                                }
                                              >
                                                <img src={blockIcon} alt="" />{" "}
                                                Block
                                                {/* <span className="open-arrow">
                                            <img src={openArrowIcon} alt="" />
                                          </span>
                                          {submenuOpen && (
                                            <ul className="submenu">
                                              <li
                                                className="submenu-item"
                                                onClick={handleMenuItemClick}
                                              >
                                                Block from this event
                                              </li>
                                              <li
                                                className="submenu-item"
                                                onClick={handleMenuItemClick}
                                              >
                                                Block from all events
                                              </li>
                                            </ul>
                                          )} */}
                                              </li>
                                              {/* <li
                                          className="dropdown-item"
                                          onClick={handleMenuItemClick}
                                        >
                                          <img src={deleteIcon} alt="" /> Remove
                                        </li> */}
                                              {ele?.state?.uuid ===
                                                stateData?.publishStreamObj
                                                  ?.screenSharingUUId && (stateData.publishStreamObj.isAdmin ||stateData.publishStreamObj.isModerator) &&(
                                                <li
                                                  className="dropdown-item"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleClickForStopShare(
                                                      ele?.state
                                                    );
                                                  }}
                                                >
                                                  <img
                                                    src={stopShareIcon}
                                                    alt=""
                                                  />{" "}
                                                  Stop Share
                                                </li>
                                              )}
                                            </ul>
                                          )}
                                        </div>
                                      )}
                                  </span>
                                </div>
                              </div>
                              <span className="participants-action"></span>
                            </li>
                          );
                        })}
                  </ul>
                </div>
              </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem uuid="b">
              {isAttendeeList && stateData.publishStreamObj.isAttendee && (
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <img src={participantsIcon} alt="participants" /> Attendees
                    ({numberOfAttendees(stateData.publishStreamObj.peoples)})
                  </AccordionItemButton>
                </AccordionItemHeading>
              )}
              {!stateData.publishStreamObj.isAttendee && (
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <img src={participantsIcon} alt="participants" /> Attendees
                    ({numberOfAttendees(stateData.publishStreamObj.peoples)})
                  </AccordionItemButton>
                </AccordionItemHeading>
              )}

              {(stateData?.publishStreamObj?.isAdmin ||
                stateData?.publishStreamObj?.isPresenter ||
                stateData?.publishStreamObj?.isModerator ||
                (stateData?.publishStreamObj.isAttendee &&
                  stateData.publishStreamObj.isAttendeeList)) && (
                <AccordionItemPanel>
                  <div className="participants-list">
                    <ul>
                      {stateData.publishStreamObj.peoples.length > 0 &&
                        stateData.publishStreamObj.peoples
                          .filter(
                            (ele) => ele?.state?.isAttendee
                            // || ele?.state?.isModerator
                          )
                          .map((ele, index) => {
                            // console.log("eleeeeeeeeeeeeeeeeeeeeee", ele);

                            return (
                              <li onClick={(e) => e.stopPropagation()}>
                                <div className="flex user-info">
                                  <span className="flex flex-center alphabet-name">
                                    {userName(ele?.state?.userName)}
                                  </span>
                                  <div className="flex joined-participants-info">
                                    <span className="username">
                                      {ele?.state?.userName}{" "}
                                      <span className="host">
                                        {/* ({userType(ele?.state)}) */}
                                      </span>
                                    </span>
                                    <span className="flex user-actions">
                                      {/* {ele?.state?.mic == false ? (
                                    <a href="#" className="flex flex-center">
                                      <img
                                        src={micMuteIcon}
                                        alt="micMuteIcon"
                                      />
                                    </a>
                                  ) : (
                                    <a href="#" className="flex flex-center">
                                      <img
                                        src={micUnMuteLightIcon}
                                        alt="micMuteIcon"
                                      />
                                    </a>
                                  )} */}

                                      {/* <a href="#" className='flex flex-center'><img src={verticalOptionIcon} alt="vertical icon" /></a> */}
                                      {!stateData.publishStreamObj
                                        ?.isAttendee &&
                                         (
                                          <div
                                            className="dropdown-area"
                                            ref={dropdownRefAttendee}
                                          >
                                            <button
                                              onClick={() => {
                                                handleDropdownClickAttendee(
                                                  index
                                                );
                                              }}
                                              className="dropdown-button"
                                            >
                                              <img
                                                src={verticalOptionIcon}
                                                alt="vertical icon"
                                              />
                                            </button>
                                            {dropdownOpenAttendee == index && (
                                              <ul className="dropdown-listing">
                                                { (
                                                  <li
                                                    className="dropdown-item"
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      handleClickForConfirmationPopup(
                                                        ele?.state?.uuid,
                                                        MSG_ENM.MAKE_COHOST,
                                                        "attendee",
                                                        index,
                                                        ele?.state.email
                                                      );
                                                      setDropdownOpenAttendee(
                                                        null
                                                      );
                                                    }}
                                                  >
                                                    <img
                                                      src={coHostIcon}
                                                      alt=""
                                                    />{" "}
                                                    Make Co Host
                                                  </li>
                                                )}
                                                {/* <li
                                          className="dropdown-item"
                                          onClick={handleMenuItemClick}
                                        >
                                          <img src={micMuteLightIcon} alt="" />{" "}
                                          Mute
                                        </li> */}
                                                <li
                                                  className="dropdown-item"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleClickForConfirmationPopup(
                                                      ele?.state?.uuid,
                                                      MSG_ENM.BLOCK,
                                                      "attendee",
                                                      index,
                                                      ele?.state.email
                                                    );
                                                  }}
                                                  onMouseEnter={
                                                    handleSubmenuMouseEnter
                                                  }
                                                  onMouseLeave={
                                                    handleSubmenuMouseLeave
                                                  }
                                                >
                                                  <img src={blockIcon} alt="" />{" "}
                                                  Block
                                                  {/* <span className="open-arrow">
                                            <img src={openArrowIcon} alt="" />
                                          </span> */}
                                                  {/* {submenuOpen && (
                                            <ul className="submenu">
                                              <li
                                                className="submenu-item"
                                                onClick={handleMenuItemClick}
                                              >
                                                Block from this event
                                              </li>
                                              <li
                                                className="submenu-item"
                                                onClick={handleMenuItemClick}
                                              >
                                                Block from all events
                                              </li>
                                            </ul>
                                          )} */}
                                                </li>
                                                {/* <li
                                          className="dropdown-item"
                                          onClick={handleMenuItemClick}
                                        >
                                          <img src={deleteIcon} alt="" /> Remove
                                        </li> */}
                                              </ul>
                                            )}
                                          </div>
                                        )}
                                    </span>
                                  </div>
                                </div>
                                <span className="participants-action"></span>
                              </li>
                            );
                          })}
                    </ul>
                  </div>
                </AccordionItemPanel>
              )}
            </AccordionItem>
          </Accordion>
        </div>
      </div>
    </>
  );
};
// export default People;
